import React, { useEffect, } from "react";
import { observer } from "mobx-react";
import { useStores } from "../hooks/useStores";
import { useTranslation } from "react-i18next";
import claimsB from "../assets/img/cards/RECLAMACIONES_B.svg";
import ClaimsMobile from '../components/ClaimsMobile';
import ClaimsTable from '../components/ClaimsTable';

const Claims = observer(() => {
  const { t } = useTranslation();
  const { myTimStore } = useStores();
  const { claims, card } = myTimStore;

  useEffect(() => {
    if (card && card.tim) {
      myTimStore.getClaims();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card.tim]);

  return (
    <div className="">
      <div className="page-title-mobile">
        {t("claims").replace("/", " ")}
        <img src={claimsB} alt="img" />
      </div>
      <div className="claims">{t("claims_text")}</div>
      <>
        <ClaimsTable claims={claims} />
        <ClaimsMobile claims={claims} />
      </>
    </div>
  );
});

export default Claims;
